import { TagCore } from '../shared/components/Tag.mjs';
import styled from '../../../../../node_modules/@mui/material/styles/styled.mjs';

const Tag = styled(TagCore)(({ theme, size, hasTopAndBottomPadding = true })=>({
        fontFamily: theme.styleConfig.fontFamily,
        fontSize: size === 'small' ? theme.typography.caption.fontSize : theme.typography.body2.fontSize,
        backgroundColor: theme.styleConfig.colors.accent,
        padding: `${hasTopAndBottomPadding ? 8 : 0}px 11px`,
        height: 'fit-content',
        color: theme.styleConfig.colors.accentText
    }));

export { Tag };
//# sourceMappingURL=Tag.mjs.map
